module.exports = __webpack_public_path__ + "static/media/ip.9e0651ab.png";